import type { SocialLink } from './Campaigns.types';
import type { ReactElement } from 'react';

import { Card, Flex, IconButton } from '@rango-dev/whale';
import React, { Fragment } from 'react';

import { DiscordIcon, XIcon } from '../../icons';
import { CampaignCarousel } from '../CampaignsCarousel';

export function Campaigns(): ReactElement {
  const socialLinks: SocialLink[] = [
    {
      id: 'profile-campaigns-x-link',
      link: 'https://x.com/RangoExchange',
      icon: <XIcon size="16" color="var(--slate-11)" />,
      label: 'X (Twitter)',
    },
    {
      id: 'profile-campaigns-discord-link',
      link: 'https://discord.com/invite/q3EngGyTrZ',
      icon: <DiscordIcon size="16" color="var(--slate-11)" />,
      label: 'Discord',
    },
  ];

  return (
    <Card variant="surface" size="3">
      <Flex direction="column" gap="4" align="center">
        <CampaignCarousel />
        <Flex gap="3" justify="center" align="center">
          {socialLinks.map(({ id, link, icon, label }) => (
            <Fragment key={id}>
              <IconButton
                id={id}
                asChild
                radius="full"
                variant="ghost"
                size={{ initial: '1', sm: '2' }}
                color="gray"
                mx="2"
                aria-label={label}>
                <a href={link} target="_blank" rel="nofollow noreferrer">
                  {icon}
                </a>
              </IconButton>
            </Fragment>
          ))}
        </Flex>
      </Flex>
    </Card>
  );
}
